export const JOB_AUTHEN_STATUS = {
  APPROVE: "approve",
  REJECT: "reject",
};

const data = [
  { key: JOB_AUTHEN_STATUS.APPROVE, label: "APPROVE" },
  { key: JOB_AUTHEN_STATUS.REJECT, label: "REJECT" },
];

export default data;

export const JobAuthenStatusComponent = ({ value }) => {
  const message = data.find((f) => f.key === value)?.label ?? "";
  let badgeType = "";
  switch (value) {
    case JOB_AUTHEN_STATUS.APPROVE:
      badgeType = "primary";
      break;
    case JOB_AUTHEN_STATUS.REJECT:
      badgeType = "danger";
      break;
  }

  return <div className={`badge badge-${badgeType}`}>{message}</div>;
};
